import { format } from 'date-fns';

export const getDateRangeLabel = (dateRange: Date[] | null): string => {
  if (!dateRange?.length) {
    return 'Dates';
  }

  const [startDate, endDate] = dateRange;

  if (!endDate) {
    return format(startDate, 'dd MMM yyyy');
  }

  return `${format(startDate, 'dd MMM yyyy')} - ${format(endDate, 'dd MMM yyyy')}`;
};
